module.exports = __webpack_public_path__ + "static/media/wordpress-1-clique.a23d136a.svg";